export default "__VITE_ASSET__Ccv_pzt___"